import focusedInboxRollupStore from '../store/store';
import getFolderChangeDigest from 'owa-mail-focused-inbox-rollup-store/lib/services/getFolderChangeDigestService';
import { getFocusedFilterForTable, getListViewTypeForFolder } from 'owa-mail-list-store';
import folderId from 'owa-service/lib/factory/folderId';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { format } from 'owa-strings';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
// Max number of unseen count to display in rollup
var MAX_UNSEEN_COUNT_TO_DISPLAY = 99;
/**
 * Action to get focused inbox rollup data
 * @param tableView for which to get rollup data
 */
export default action('getFolderChangeDigestAction')(function getFolderChangeDigestAction(tableView) {
    var isFocusedView = getFocusedFilterForTable(tableView) == 0 /* Focused */;
    var viewType = isFocusedView ? 1 /* FocusedView */ : 2 /* ClutterView */;
    var watermark = isFocusedView
        ? getUserConfiguration().ViewStateConfiguration.FocusedViewWatermark
        : getUserConfiguration().ViewStateConfiguration.ClutterViewWatermark;
    focusedInboxRollupStore.viewType = viewType;
    getFolderChangeDigest(targetFolderId({ BaseFolderId: folderId({ Id: tableView.tableQuery.folderId }) }), viewType, watermark, getListViewTypeForFolder(tableView.tableQuery.folderId) == 0 /* Conversation */).then(function (response) { return processResponse(response); });
});
// Process GetFolderChangeDigestResponse
function processResponse(response) {
    if (response.Folders == null || response.Folders.length == 0) {
        // GetFolderChangeDigestResponse.Folders can be null in case of server exception while processing the request
        trace.info('GetFolderChangeDigestResponse.Folders is null or empty');
        return;
    }
    var folder = response.Folders[0];
    // Update rollup store state with response data
    focusedInboxRollupStore.uniqueSenders = folder.RecentUniqueSenders.join('; ').toString();
    focusedInboxRollupStore.unseenCountToDisplay = getUnseenCountToDisplay(folder.UnseenCount);
}
// Get unseen count to dsiplay in rollup
function getUnseenCountToDisplay(count) {
    if (count === 0) {
        return null;
    }
    if (count > MAX_UNSEEN_COUNT_TO_DISPLAY) {
        return format('{0}+', MAX_UNSEEN_COUNT_TO_DISPLAY);
    }
    return count.toString();
}
//# sourceMappingURL=getFolderChangeDigestAction.js.map